import { api } from '@/scripts/api';

export const LandingPageSectionService = {

    get(id) {
        return new Promise((resolve, reject) => {
            const service = '/service/LandingPageSections';
            const endpoint = api.applyODataParams(service, {
                filter: `Id eq ${ id }`,
                expand: 'Categories($select=Name)'
            });

            api.get(endpoint)
                .then(resolve)
                .catch(reject);
        });

    },

    getAll(config = {}, signal) {
        return new Promise((resolve, reject) => {
            const service = '/service/LandingPageSections';
            const endpoint = api.applyODataParams(service, config);

            api.get(endpoint, signal)
                .then(resolve)
                .catch(error => {
                    if (!api.isCanceled(error)) {
                        reject(error);
                    }
                });
        });
    },

    post(payload) {
        return new Promise((resolve, reject) => {
            const service = '/api/LandingPageSections';

            api.post(service, payload)
                .then(resolve)
                .catch(reject)

        });
    },

    patch(id, payload) {
        return new Promise((resolve, reject) => {
            const service = `/api/LandingPageSections/${ id }`;

            api.patch(service, payload)
                .then(resolve)
                .catch(reject);
        });
    },

    setDefault(id) {
        return new Promise((resolve, reject) => {
            const service = `/api/LandingPageSections/${id}/SetDefault`;

            api.post(service)
                .then(resolve)
                .catch(reject);
        });
    },

    delete(id) {
        return new Promise((resolve, reject) => {
            const service = `/api/LandingPageSections/${ id }`;

            api.delete(service)
                .then(resolve)
                .catch(reject)
        });
    },

    deleteAll(ids) {
        return new Promise((resolve, reject) => {
            const service = '/api/LandingPageSections/';

            api
                .delete(service, ids)
                .then(resolve)
                .catch(reject);
        });
    },

    duplicate(id) {
        return new Promise((resolve, reject) => {
            const service = `/api/LandingPageSections/${ id }/Duplicate`;

            api.post(service)
                .then(resolve)
                .catch(reject)
        });
    },

    publish(id, clientIds) {
        return new Promise((resolve, reject) => {
            const service = `/api/LandingPageSections/${ id }/Publish`;

            api
                .post(service, clientIds)
                .then(resolve)
                .catch(reject);
        });

    },

    unpublish(id) {
        return new Promise((resolve, reject) => {
            const service = `/api/LandingPageSections/${ id }/Publish`;

            api
                .post(service, [])
                .then(resolve)
                .catch(reject);
        });
    },

    addToMySections(accountId, id) {
        return new Promise((resolve, reject) => {
            const service = `/api/Accounts/${accountId}/LandingPageSections/${id}/Add`;

            api
                .post(service)
                .then(resolve)
                .catch(reject)
        })
    },

    
    bulkAutoPublishLandingPageSections(payload) {
        return new Promise((resolve, reject) => {
            api
                .post('/api/LandingPageSections/AutoPublish', payload)
                .then(resolve)
                .catch(reject)
        })
    },

    bulkAddCategoriesToLandingPageSection(payload) {
        return new Promise((resolve, reject) => {
            api
                .post('/api/LandingPageSections/BulkAddCategory', payload)
                .then(resolve)
                .catch(reject)
        })
    },

    getSharedAssets(id, config = {}) {
        return new Promise((resolve, reject) => {
            const service = '/service/SharedAssets';

            const endpoint = api.applyODataParams(service, {
                ...config,
                filter: `LandingPageSectionId eq ${ id }`,
            });

            api
                .get(endpoint)
                .then(resolve)
                .catch(reject);
        })
    },


    getClient(id, config = {}) {
        return new Promise((resolve, reject) => {
            const service = '/service/Clients';

            const endpoint = api.applyODataParams(service, {
                ...config,
                filter: `Id eq ${ id }`,
            });

            api
                .get(endpoint)
                .then(resolve)
                .catch(reject);
        })
    },

    getClients(config = {}) {
        return new Promise((resolve, reject) => {
            const service = '/service/Clients';

            const endpoint = api.applyODataParams(service, config);

            api
                .get(endpoint)
                .then(resolve)
                .catch(reject);
        })
    },

};
